import { YesNoAnswer } from "../../../incidentLog/IncidentLogDialog.types.ts";

// The template editor preview shows every field so the whole template can be reviewed, even the justification and
// the date the data subject was informed, which stay hidden until the deadline is known to be extended.
export function showsDeadlineExtensionDetails(answer: YesNoAnswer | null | undefined, isPreview: boolean) {
    return isPreview || answer === YesNoAnswer.Yes;
}
